import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  FormGroup,
  Icon,
  TextField,
  Typography,
} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";
import { Grid } from "@mui/material";
import { Select } from "antd";
import AutocompleteExtension from "components/autocomplete/AutocompleteExtension";
import { OUTBOUND_CALL_STATUS_OPTIONS } from "constant";
import { saveAs } from "file-saver";
import _, { debounce } from "lodash";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { getData } from "../../api/apiCaller";
import { mapActionsToProps as extensionAction } from "../../redux/cloudPBX/extension";
import {
  exportOutbound,
  mapActionsToProps,
} from "../../redux/cloudPBX/outboundCall";
import { mapActionsToProps as phoneNumberAction } from "../../redux/cloudPBX/phoneNumber";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";
import { mapActionsToProps as agent } from "./../../redux/agent";
import { mapActionsToProps as campaigns } from "./../../redux/campaigns";
import { mapActionsToProps as clickToCallAction } from "./../../redux/cloudPBX/clickToCall";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
    overflow: "unset",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  bulletOffline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "red",
  },
  bulletOnline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "chartreuse",
  },
  export: {
    width: "90px",
    height: "35px",
    float: "right",
    marginTop: "-55px",
    fontSize: "16px",
  },
});

const mno = [
  {
    id: "",
    name: "Tất cả",
  },
  {
    id: "gpc",
    name: "Vinaphone",
  },
  {
    id: "viettel",
    name: "Viettel",
  },
  {
    id: "vms",
    name: "Mobifone",
  },
  {
    id: "gtel",
    name: "GMobile",
  },
  {
    id: "itel",
    name: "Indochina Telecom",
  },
  {
    id: "vnm",
    name: "Vietnam Mobile",
  },
  {
    id: "fixed",
    name: "Cố định",
  },
];

const renderStatus = (status) => {
  const statusName = {
    answered: "Trả lời",
    busy: "Bận",
    "no-answered": "Không trả lời",
  };
  return statusName[status] || status;
};

const getRecordFileUrl = (item) => {
  if (
    item.recordFileS3 &&
    item.recordFileS3 !== "not-exists" &&
    !item.recordFileS3.includes("error")
  ) {
    return item.recordFileS3;
  } else if (item.recordFile) {
    return item.recordFile;
  }
  return "";
};
class OutBoundCall extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      note: "",
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "processedAt DESC, startedAt DESC",
        where: {
          gte: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD startDayNoSec"),
          lte: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD endDayNoSec"),
          status: null,
          callStatus: null, // trạng thái nhà mạng
          from: "",
          mno: "",
          cityCodes: [],
          ladingCode: "",
        },

        page: 0,
        pageSize: 20,
      },
      item: null,
      modalEdit: false,
      modalDelete: false,
      showPassword: false,
      modalAction: false,
      agentGroupId: null,
      loadingExcel: false,
      listExtension: [],
      listCampaign: [],
      selectedPhone: "",
      campaignSelect: null,
      listCities: null,
    };
  }
  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
    this.props.getListPhoneNumber();
    this.props.getListGroupAgent();
    this.props.getAllCampaigns();
    this.callApiGetCities();
  }

  async callApiGetCities(name = null, limit) {
    const where = {
      ...(name && { name: { like: name, options: "i" } }),
    };
    const { data } = await getData("/vnpost/city-post-office", {
      filter: { where, limit, order: "code ASC" },
    });
    this.setState({ listCities: data });
  }

  static getDerivedStateFromProps(props, state) {
    if (
      JSON.parse(JSON.stringify(state.listExtension)) !==
        JSON.parse(JSON.stringify(_.values(props.listExtension))) &&
      !state.listExtension.length
    ) {
      return {
        listExtension: _.values(props.listExtension),
      };
    }
    return null;
  }

  listCollumns = [
    {
      id: "from",
      numeric: true,
      disablePadding: false,
      label: "Số điện thoại gọi",
    },
    {
      numeric: true,
      disablePadding: false,
      label: "Số điện thoại nhận",
      customValue: (row) => (
        <Typography variant="body2" gutterBottom style={{ display: "flex" }}>
          <Icon style={{ fontSize: "20px", marginRight: "5px" }}>call</Icon>
          {row.to}
        </Typography>
      ),
    },
    {
      id: "agent",
      numeric: true,
      disablePadding: false,
      label: "Điện thoại viên",
    },
    { id: "extension", numeric: true, disablePadding: false, label: "Máy lẻ" },
    {
      id: "startedAt",
      numeric: true,
      disablePadding: false,
      label: "Thời gian gọi",
      type: "outbound",
    },
    {
      id: "answeredDuration",
      numeric: true,
      disablePadding: false,
      label: "Thời lượng gọi ra",
    },

    {
      numeric: true,
      disablePadding: false,
      label: "Trạng thái",
      customValue: (row) => <>{renderStatus(row.status)}</>,
    },
    {
      id: "campaignName",
      numeric: true,
      disablePadding: false,
      label: "Chiến dịch",
    },
    {
      id: "recordFileS3",
      numeric: true,
      disablePadding: false,
      label: "Ghi âm",
    },
    { id: "note", numeric: true, disablePadding: false, label: "Ghi chú" },
    {
      id: "subOrgName",
      numeric: true,
      disablePadding: false,
      label: "Bưu cục",
    },
    {
      id: "callStatus",
      label: "Trạng thái nhà mạng",
    },
    {
      id: "callStatusCode",
      label: "Mã trạng thái",
    },
    { id: "view", numeric: true, disablePadding: false, label: "Chi tiết" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const query = {};
    const { filters, agentGroupId } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "answeredDuration":
              let _and = [];
              switch (element) {
                case "1":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 0,
                      },
                    },
                    {
                      answeredDuration: {
                        lt: 60,
                      },
                    },
                  ];
                  break;
                case "2":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 60,
                      },
                    },
                    {
                      answeredDuration: {
                        lt: 180,
                      },
                    },
                  ];
                  break;
                case "3":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 180,
                      },
                    },
                    {
                      answeredDuration: {
                        lt: 300,
                      },
                    },
                  ];
                  break;
                case "4":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 300,
                      },
                    },
                    {
                      answeredDuration: {
                        lt: 600,
                      },
                    },
                  ];
                  break;
                case "5":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 600,
                      },
                    },
                  ];
                  break;
                default:
                  break;
              }
              where.and = and.concat(_and);
              break;
            case "from":
            case "to":
            case "status":
            case "extensionId":
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key == "gte") {
                  and.push({
                    startedAt: { gte: this.state.filters.where.gte },
                  });
                  where.and = and;
                } else {
                  and.push({
                    startedAt: { lte: this.state.filters.where.lte },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }

    if (agentGroupId === null) {
      this.props.getOutboundCall(
        filters.order,
        filters.pageSize,
        filters.page,
        { where },
        filters.query
      );
    } else {
      this.props.getOutboundCallAgent(
        agentGroupId,
        filters.order,
        filters.pageSize,
        filters.page,
        {
          where,
        },
        filters.query
      );
    }
    this.props.countOutBoundCall({ where });
    this.props.getListExtension(filters.order, 999, null, null, {
      include: ["pbx"],
    });
  }

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearchGroup = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    this.setState({
      [name]: value,
    });
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    if (name === "from") {
      if (value && value.length > 0 && value.indexOf("Tất cả") > -1) {
        filters.where[name] = "";
      } else {
        filters.where[name] = {
          inq: value,
        };
      }
    } else {
      filters.where[name] = value;
    }

    if (name === "campaignId" && value) {
      filters.where[name] = { like: value };
    }

    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    if (this.state.selectedPhone) {
      filters.where["extensionId"] = this.state.selectedPhone;
    } else {
      delete filters.where["extensionId"];
    }
    if (this.state.campaignSelect) {
      filters.where["campaignId"] = this.state.campaignSelect;
    } else {
      delete filters.where["campaignId"];
    }
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleView = (item) => {
    this.state.item = item;
    this.setState({ modalView: !this.state.modalView });
  };

  handleCloseModel = () => {
    this.setState({ modalView: false });
  };

  handleDateChangeStart = (gte) => {
    const { filters } = this.state;
    filters.where.gte = datetimeHelper.toFormat(
      gte,
      "YYYY-MM-DD startDayNoSec"
    );
    this.setState({ gte });
  };

  handleDateChangeEnd = (lte) => {
    const { filters } = this.state;
    filters.where.lte = datetimeHelper.toFormat(lte, "YYYY-MM-DD endDayNoSec");
    this.setState({ lte });
  };

  callNumber = (item) => {
    const { agentStatus } = this.props;
    this.props.handleClickToCall({
      outboundId: item.id,
      extensionId: agentStatus ? agentStatus.extensionId : null,
    });
  };

  export = () => {
    const { filters } = this.state;
    const where = {};
    const and = [];
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "answeredDuration":
              let _and = [];
              switch (element) {
                case "1":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 0,
                      },
                    },
                    {
                      answeredDuration: {
                        lt: 60,
                      },
                    },
                  ];
                  break;
                case "2":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 60,
                      },
                    },
                    {
                      answeredDuration: {
                        lt: 180,
                      },
                    },
                  ];
                  break;
                case "3":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 180,
                      },
                    },
                    {
                      answeredDuration: {
                        lt: 300,
                      },
                    },
                  ];
                  break;
                case "4":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 300,
                      },
                    },
                    {
                      answeredDuration: {
                        lt: 600,
                      },
                    },
                  ];
                  break;
                case "5":
                  _and = [
                    {
                      answeredDuration: {
                        gte: 600,
                      },
                    },
                  ];
                  break;
                default:
                  break;
              }
              where.and = and.concat(_and);
              break;
            case "from":
            case "to":
            case "status":
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key == "gte") {
                  and.push({
                    startedAt: { gte: this.state.filters.where.gte },
                  });
                  where.and = and;
                } else {
                  and.push({
                    startedAt: { lte: this.state.filters.where.lte },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }

    this.setState(
      {
        loadingExcel: true,
      },
      () => {
        exportOutbound({ where: where })
          .then((res) => {
            this.setState(
              {
                loadingExcel: false,
              },
              () => {
                if (res.data.fileUrl) {
                  const fileName = res.data.fileUrl.split("/").pop();
                  saveAs(res.data.fileUrl, fileName);
                }
              }
            );
          })
          .catch((error) => {
            this.setState({
              loadingExcel: false,
            });
          });
      }
    );
  };

  formatNmo = (string) => {
    if (typeof value === "object" && string !== null) {
      return string.name;
    } else if (string === "gpc") {
      return "Vinaphone";
    } else if (string === "viettel") {
      return "Viettel";
    } else if (string === "vms") {
      return "Mobifone";
    } else if (string === "gtel") {
      return "GMobile";
    } else if (string === "itel") {
      return "Indochina Telecom";
    } else if (string === "vnm") {
      return "Vietnam Mobile";
    } else if (string === "fixed") {
      return "Cố định";
    }
  };

  handleSearchPhone = (text) => {
    const { listExtension } = this.props;
    this.setState({
      listExtension: this.filterCustomers(_.values(listExtension), text),
    });
  };

  filterCustomers = (array, search) => {
    if (search) {
      return search
        ? array.filter(
            (item) =>
              (item &&
                item.name &&
                item.name.toLowerCase().includes(search.toLowerCase())) ||
              (item &&
                item.username &&
                item.username.toLowerCase().includes(search.toLowerCase()))
          )
        : array;
    }
    return array;
  };

  handleSearchCampaign = (text = "") => {
    const { listCampaign } = this.props;
    this.setState({
      listCampaign: this.filterCampaign(_.values(listCampaign), text),
    });
  };

  filterCampaign = (array, search) => {
    if (search) {
      return search
        ? array.filter(
            (item) =>
              item &&
              item.name &&
              item.name.toLowerCase().includes(search.toLowerCase())
          )
        : array;
    }
    return array;
  };

  onHandleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.handleSubmit();
    }
  };

  onChangeFilters(name, value) {
    this.setState({ [name]: value });
  }

  onChangeFiltersSearch(name, value) {
    const { contacts = [] } = this.props;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({ filters: filters });
  }

  onChangeSelectFilters = (name, value) => {
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({ filters });
  };

  onChangeSelectAnt = (name, value) => {
    this.setState({ [name]: value });
  };

  render() {
    const {
      classes,
      listLogOutboundCall,
      count,
      listExtension,
      listPhoneNumber,
      listAgentGroups,
      listCampaign,
    } = this.props;
    const { filters, listCities } = this.state;
    const listLogOutboundCallResult =
      typeof listLogOutboundCall === "object"
        ? Object.keys(listLogOutboundCall).map(
            (key) => listLogOutboundCall[key]
          )
        : listLogOutboundCall;
    const listExtensionResult =
      typeof listExtension === "object"
        ? Object.keys(listExtension).map((key) => listExtension[key])
        : listExtension;
    const listPhoneNumberResult =
      typeof listPhoneNumber === "object"
        ? Object.keys(listPhoneNumber).map((key) => listPhoneNumber[key])
        : listPhoneNumber;
    const listAgentGroupsResult =
      typeof listAgentGroups === "object"
        ? Object.keys(listAgentGroups).map((key) => listAgentGroups[key])
        : listAgentGroups;
    const listCampaignResult =
      typeof listCampaign === "object"
        ? Object.keys(listCampaign).map((key) => listCampaign[key])
        : listCampaign;

    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormGroup className={classes.form}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container spacing={2}>
                    <Grid item md={3}>
                      <SelectValidator
                        id="outlined-full-width"
                        margin="normal"
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                            shrink: true,
                          },
                          multiple: true,
                          renderValue: (value) => value.join(", "),
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label="Số điện thoại gọi"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={
                          filters.where.from && filters.where.from.inq
                            ? filters.where.from.inq
                            : []
                        }
                        name="from">
                        <MenuItem value={"Tất cả"}>
                          <Checkbox checked={filters.where.from === ""} />
                          <ListItemText primary={"Tất cả"} />
                        </MenuItem>
                        {listPhoneNumberResult &&
                          listPhoneNumberResult.length > 0 &&
                          listPhoneNumberResult.map((value, key) => (
                            <MenuItem key={key} value={value.id}>
                              <Checkbox
                                checked={
                                  filters.where.from &&
                                  filters.where.from.inq &&
                                  filters.where.from.inq.indexOf(value.id) > -1
                                }
                              />
                              <ListItemText primary={value.id} />
                            </MenuItem>
                          ))}
                      </SelectValidator>
                    </Grid>
                    <Grid item md={3}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Số điện thoại nhận"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.to}
                        autoComplete="off"
                        name="to"
                        onKeyPress={(e) => this.onHandleKeyPress(e)}
                      />
                    </Grid>
                    <Grid item md={3}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Mã bưu gửi"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.ladingCode}
                        autoComplete="off"
                        name="ladingCode"
                        onKeyPress={(e) => this.onHandleKeyPress(e)}
                      />
                    </Grid>

                    <Grid item md={3}>
                      <div style={{ marginTop: 12 }}>
                        <AutocompleteExtension
                          value={this.state.selectedPhone}
                          onChange={(extensionId) => {
                            this.setState({ selectedPhone: extensionId ?? "" });
                          }}
                        />
                      </div>
                    </Grid>

                    <Grid item md={3} className="flexGridCareReport">
                      <div
                        className="autocomplete-list-phone-number__container"
                        // style={{ marginTop: 14 }}
                      >
                        <label className="autocomplete-list-phone-number__label">
                          Bưu điện tỉnh/thành phố
                        </label>
                        <Select
                          showSearch
                          mode="multiple"
                          showArrow={true}
                          placeholder="Tất cả"
                          optionFilterProp="children"
                          className="autocomplete-list-phone-number__select"
                          popupClassName="autocomplete-list-phone-number__dropdown"
                          value={filters.where.cityCodes}
                          onChange={this.onChangeSelectFilters.bind(
                            this,
                            "cityCodes"
                          )}
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          options={[
                            ...(listCities || []).map((d) => ({
                              value: d.code,
                              label: `${d.code} - ${d.name}`,
                            })),
                          ]}
                        />
                      </div>
                    </Grid>

                    <Grid item md={6} className="flexGridCareReport">
                      <div className="autocomplete-list-phone-number__container">
                        <label className="autocomplete-list-phone-number__label">
                          Trạng thái nhà mạng
                        </label>
                        <Select
                          showSearch
                          showArrow={true}
                          placeholder="Tất cả"
                          optionFilterProp="children"
                          className="autocomplete-list-phone-number__select"
                          popupClassName="autocomplete-list-phone-number__dropdown"
                          value={filters.where.callStatus || null}
                          onChange={this.onChangeSelectFilters.bind(
                            this,
                            "callStatus"
                          )}
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          options={[
                            { value: null, label: "Tất cả" },
                            ...OUTBOUND_CALL_STATUS_OPTIONS,
                          ]}
                        />
                      </div>
                    </Grid>
                    <Grid item md={3} className="flexGridCareReport">
                      <div className="autocomplete-list-phone-number__container">
                        <label className="autocomplete-list-phone-number__label">
                          Trạng thái
                        </label>
                        <Select
                          showSearch
                          showArrow={true}
                          placeholder="Tất cả"
                          optionFilterProp="children"
                          className="autocomplete-list-phone-number__select"
                          popupClassName="autocomplete-list-phone-number__dropdown"
                          value={filters.where.status || null}
                          onChange={this.onChangeSelectFilters.bind(
                            this,
                            "status"
                          )}
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          options={[
                            { value: null, label: "Tất cả" },
                            { value: "answered", label: "Trả lời" },
                            { value: "busy", label: "Bận" },
                            { value: "no-answered", label: " Không trả lời" },
                          ]}
                        />
                      </div>
                    </Grid>

                    <Grid item md={3} className="flexGridCareReport">
                      <div
                        className="autocomplete-list-phone-number__container"
                        style={{ marginTop: 14 }}>
                        <label className="autocomplete-list-phone-number__label">
                          Chiến dịch
                        </label>
                        <Select
                          showSearch
                          showArrow={true}
                          placeholder="Tất cả"
                          optionFilterProp="children"
                          className="autocomplete-list-phone-number__select"
                          popupClassName="autocomplete-list-phone-number__dropdown"
                          value={this.state.campaignSelect}
                          onChange={this.onChangeSelectAnt.bind(
                            this,
                            "campaignSelect"
                          )}
                          onFocus={debounce(
                            () => this.handleSearchCampaign(),
                            300
                          )}
                          onSearch={debounce(
                            (input) => this.handleSearchCampaign(input),
                            300
                          )}
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          options={[
                            { value: null, label: "Tất cả" },
                            ...(this.state.listCampaign || []).map((d) => ({
                              value: d.id,
                              label: `${d.name}`,
                            })),
                          ]}
                        />
                      </div>
                    </Grid>

                    <Grid item md={3} className="flexGridCareReport">
                      <div
                        className="autocomplete-list-phone-number__container"
                        style={{ marginTop: 14 }}>
                        <label className="autocomplete-list-phone-number__label">
                          Thời lượng trả lời
                        </label>
                        <Select
                          showSearch
                          placeholder="Tất cả"
                          optionFilterProp="children"
                          value={filters.where.answeredDuration}
                          className="autocomplete-list-phone-number__select"
                          popupClassName="autocomplete-list-phone-number__dropdown"
                          onChange={this.onChangeFiltersSearch.bind(
                            this,
                            "answeredDuration"
                          )}
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          options={[
                            { value: null, label: "Tất cả" },
                            { value: "1", label: "Cuộc gọi nhỏ hơn 1 phút" },
                            {
                              value: "2",
                              label: "Cuộc gọi từ 1 phút đến 3 phút",
                            },
                            {
                              value: "3",
                              label: "Cuộc gọi từ 3 phút đến 5 phút",
                            },
                            {
                              value: "4",
                              label: "Cuộc gọi từ 5 phút đến 10 phút",
                            },
                            { value: "5", label: "Cuộc gọi lớn hơn 10 phút" },
                          ]}
                        />
                      </div>
                    </Grid>

                    <Grid item md={3}>
                      <InlineDatePicker
                        label="Thời gian gọi từ"
                        variant="outlined"
                        className={classes.input}
                        value={filters.where.gte}
                        maxDate={new Date()}
                        format="dd-MM-yyyy"
                        onChange={this.handleDateChangeStart}
                        name="gte"
                        keyboard
                        invalidDateMessage="Định dạng Ngày không đúng"
                        maxDateMessage="Ngày lớn hơn ngày tối đa"
                        minDateMessage="Ngày nhỏ hơn ngày tối thiểu"
                        ampm={false}
                      />
                    </Grid>

                    <Grid item md={3}>
                      <InlineDatePicker
                        label="Thời gian gọi đến"
                        variant="outlined"
                        className={classes.input}
                        value={filters.where.lte}
                        maxDate={new Date()}
                        minDate={filters.where.gte}
                        format="dd-MM-yyyy"
                        onChange={this.handleDateChangeEnd}
                        name="lte"
                        invalidDateMessage="Định dạng Ngày không đúng"
                        maxDateMessage="Ngày lớn hơn ngày tối đa"
                        minDateMessage="Ngày nhỏ hơn ngày tối thiểu"
                        keyboard
                        ampm={false}
                      />
                    </Grid>
                    <Grid item md={3}>
                      <Tooltip title="Tìm kiếm" disableFocusListener>
                        <Fab
                          color="primary"
                          aria-label="Search"
                          className={classes.fab}
                          onClick={this.handleSubmit}>
                          <Search />
                        </Fab>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </MuiPickersUtilsProvider>
              </FormGroup>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách log cuộc gọi ra"
          items={listLogOutboundCallResult}
          rowsPerPage={filters.pageSize}
          count={count ? count.count : 0}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          handleView={this.handleView}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          callNumber={this.callNumber}
          createAction={
            <React.Fragment>
              <Tooltip title="Tải báo cáo" disableFocusListener>
                <Fab
                  color="primary"
                  size="small"
                  aria-label="export"
                  className={classes.fab}
                  onClick={this.export}>
                  <Icon className={classes.add}>save_alt</Icon>
                </Fab>
              </Tooltip>
            </React.Fragment>
          }
        />
        <Dialog
          open={this.state.modalView}
          onClose={this.handleCloseModel}
          title="Chi tiết log cuộc gọi ra"
          buttonExit={true}
          input={
            <Grid container spacing={2}>
              <audio
                ref="audio"
                src={this.state.item ? getRecordFileUrl(this.state.item) : ""}
                controls
                autoPlay={false}
                style={{ width: "100%", marginTop: 20 }}
              />
              <Grid item md={6}>
                <TextField
                  id="standard-name"
                  label="Số điện thoại gọi"
                  className={classes.input}
                  value={this.state.item ? this.state.item.from : ""}
                  margin="normal"
                />
                <TextField
                  id="standard-name"
                  label="Điện thoại viên thực hiện"
                  className={classes.input}
                  value={
                    this.state.item
                      ? this.state.item.agent
                        ? this.state.item.agent.user
                          ? this.state.item.agent.user.fullname
                          : ""
                        : ""
                      : ""
                  }
                  margin="normal"
                />
                <TextField
                  id="standard-name"
                  label="Thời gian gọi"
                  className={classes.input}
                  value={
                    this.state.item
                      ? datetimeHelper.toFormat(
                          this.state.item.startedAt,
                          "YYYY-MM-DD"
                        )
                      : ""
                  }
                  margin="normal"
                />
                <TextField
                  id="standard-name"
                  label="Thời gian trả lời"
                  className={classes.input}
                  value={
                    this.state.item
                      ? datetimeHelper.secondToHHMMSS(
                          this.state.item.answeredDuration
                        )
                      : ""
                  }
                  margin="normal"
                />
              </Grid>
              <Grid item md={6}>
                <TextField
                  id="standard-name"
                  label="Số điện thoại nhận"
                  className={classes.input}
                  value={this.state.item ? this.state.item.to : ""}
                  margin="normal"
                />
                <TextField
                  id="standard-name"
                  label="Số máy lẻ"
                  className={classes.input}
                  value={
                    this.state.item
                      ? this.state.item.extension
                        ? this.state.item.extension.name
                        : ""
                      : ""
                  }
                  margin="normal"
                />
                <TextField
                  id="standard-name"
                  label="Trạng thái"
                  className={classes.input}
                  value={this.state.item ? this.state.item.status : ""}
                  margin="normal"
                />
                <TextField
                  id="standard-name"
                  label="Thời gian kết nối"
                  className={classes.input}
                  value={
                    this.state.item
                      ? datetimeHelper.secondToHHMMSS(this.state.item.duration)
                      : ""
                  }
                  margin="normal"
                />
              </Grid>
              <Grid item md={12}>
                <TextField
                  id="standard-name"
                  label="Ghi chú"
                  className={classes.input}
                  value={this.state.item ? this.state.item.note : ""}
                  margin="normal"
                />
              </Grid>
            </Grid>
          }
        />
        <Dialog open={this.props.loading} title={<CircularProgress />} />
        <Dialog open={this.state.loadingExcel} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

OutBoundCall.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listLogOutboundCall: state.outBoundCall.outBound,
  excel: state.outBoundCall.excel,
  count: state.outBoundCall.count,
  listExtension: state.extension.extensions,
  agentStatus: state.agent.status,
  loading: state.outBoundCall.loading,
  listPhoneNumber: state.phoneNumber.phoneNumbers,
  listAgentGroups: state.agent.groupAgent,
  listCampaign: state.campaign.allCampaign,
});

OutBoundCall = connect(mapStateToProps, mapActionsToProps)(OutBoundCall);
const ClickToCall = connect(null, clickToCallAction)(OutBoundCall);
const Agent = connect(null, agent)(ClickToCall);
const ExtensionAction = connect(null, extensionAction)(Agent);
const PhoneNumber = connect(null, phoneNumberAction)(ExtensionAction);
const Campaigns = connect(null, campaigns)(PhoneNumber);

export default withStyles(styles)(Campaigns);
